import richTextFragment from '@components/renderers/rich-text.fragment'

export const liveEventPostFragment = `
  total
  items {
    content
    livePostAuthor {
      name
      avatar {
        url
      }
    }
    livePostPublisher {
      name
      logo {
        url
        height
        width
      }
    }
    body {
      ${richTextFragment}
    }
    sys {
      id
      firstPublishedAt
      publishedAt
    }
  }
`
